module.exports = __webpack_public_path__ + "img/jiancha.16487467.png";